import { call } from 'redux-saga/effects';
import { memberIsActive } from 'redux/saga/helpers/member';

export function* pricingOnEnter(client, nextState, replaceState) {
  if (yield call(memberIsActive, client)) {
    return yield call(replaceState, '/classes');
  }
}
